import type {DateValueEditorLocalizations, DateValueEditorOptions} from './types';
import type {DefaultOptions} from '../../../types';

export const DATE_VALUE_EDITOR_DEFAULT_OPTIONS: DefaultOptions<DateValueEditorOptions> = {
    viewFormat: 'd.L.y',
    onlyDate: false,
    maximumGranularity: 'date-only',
};

export const DATE_VALUE_EDITOR_DEFAULT_LOCALIZATIONS = Object.freeze<DateValueEditorLocalizations>({
    description: '',
    openCalendar: 'Open calendar popup (be advised, keyboard navigation could be complicated)',
    timeView: 'Show time view',
    backToDate: 'Back to calendar view',
    todayBtn: 'Today',
    clearBtn: 'Clear'
});